var map = {
	"./exam-center.png": 81455,
	"./permission-mana.png": 31118,
	"./report-template.png": 78605,
	"./research-mana.png": 23196,
	"./school-mana.png": 49020,
	"./style-analysis.png": 97470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98346;